import React, { FC, useEffect, useState } from 'react'
import styles from "../../assets/styles/layout.module.css"
import { AvtarIcon, CartIcon, CrossIcon, DropdownRightIcon, LogoutIcon, PhoneIcon, SearchIcon, UploadIcon, WhatsappIcon } from '../../utils/functions/Icons'
import LogoIcon from "../../assets/images/layout/header/logo.png"
import { Box, Input, InputAdornment, Skeleton } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '../../utils/store/AllReducers'
import { useDispatch } from 'react-redux'
import { setTabValue } from '../../utils/store/myaccount/MyAccountSlice'
import { myAccountLists } from '../../utils/functions/CustomData'
import { AppDispatch } from '../../utils/store'
import { useLazyGetAiSearchDataQuery, useLazyGetSearchDataQuery } from '../../utils/store/common/commonApi'
import { handleOpenLogoutModal } from '../../utils/store/auth/AuthSlice'
import LogoutModal from '../common/LogoutModal'
import { slugify } from '../../utils/functions/functions'
import Image from '../common/Image'

interface props {
    primaryMenuData: PrimaryMenuCategory[] | undefined;
    isLoading: boolean
}
const Header: FC<props> = ({ primaryMenuData, isLoading }) => {
    const [searchResultShow, setSearchResultShow] = useState(false)
    const [searchValue, setSearchValue] = useState('');
    const [searchMode, setSearchMode] = useState<'medicine' | 'symptom'>('medicine');
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const { userLogin } = useSelector((state: RootState) => state.auth)
    const [handleSearchData, { data: searchDataList, isLoading: searchLoading, isFetching: searchFetching }] = useLazyGetSearchDataQuery();
    const [handleAISearchData, { data: searchAIDataList, isLoading: AiLoading, isFetching: AIFetching }] = useLazyGetAiSearchDataQuery();
    const cartCount = useSelector((state: RootState) => state.cart.cartData.totalItem);

    const handleSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value)
        if (e.target.value) {
            setSearchResultShow(true)
        }
        else {
            setSearchResultShow(false)
        }
    }

    useEffect(() => {
        if (searchResultShow) {
            if (searchValue) {
                const cleanFunction = setTimeout(() => {
                    if (searchMode === "symptom") {
                        handleAISearchData(searchValue?.toLowerCase());
                    } else {
                        handleSearchData(searchValue);
                    }
                }, 1000)
                return () => clearInterval(cleanFunction)
            }
            else {
                if (searchMode === "symptom") {
                    handleAISearchData("");
                } else {
                    handleSearchData("");
                }
            }
        }
    }, [searchValue, searchMode, handleSearchData, handleAISearchData, searchResultShow]);

    const handleSearchClick = (link: string, id: number) => {
        setSearchResultShow(false)
        setSearchValue("")
        navigate(`${link}?${new URLSearchParams({ q: `${id}` })}`, { state: id })
    }
    return (
        <div className={styles.headerMain}>
            <div className={styles.topbarMain}>
                <div className="container-fluid">
                    <div className={styles.topbarcontentMain}>
                        <div className={styles.topbarLeft}>
                            <p>We deliver medicine through prescription !</p>
                        </div>
                        <div className={styles.topbarRight}>
                            <a href='tel:+919625996301' className={styles.rightContentMain} rel='noreferrer'>
                                <PhoneIcon color='white' />
                                <span>+919625996301</span>
                            </a>
                            <a href='https://api.whatsapp.com/send/?phone=919625996301&text&type=phone_number&app_absent=0' target='_blank' className={styles.rightContentMain} rel='noreferrer'>
                                <WhatsappIcon color='white' />
                                <span>Order on Whatsapp</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <nav className={styles.navbarMain}>
                <div className="container-fluid">
                    <div className={styles.navbarContentMain}>
                        <div className={styles.navbarLeftMain}>
                            <div className={styles.logo} onClick={() => navigate('/')}>
                                <Image src={LogoIcon} alt="mchemist logo" />
                            </div>
                        </div>
                        <div className={styles.searchAndAddressSection}>
                            <div className={styles.searchAndAddressMain}>
                                <div className={styles.toggleSwitchContainer}>
                                    <div className={styles.toggleSwitch}>
                                        <div
                                            className={`${styles.switchThumb} ${searchMode === 'symptom' ? styles.thumbRight : ''}`}
                                        />

                                        <button
                                            className={`${styles.switchBtn} ${searchMode === 'medicine' ? styles.activeBtn : ''}`}
                                            onClick={() => {
                                                setSearchValue("");
                                                setSearchMode('medicine')
                                            }}
                                        >
                                            {
                                                searchLoading || searchFetching ? "Loading..." : "Medicine"
                                            }
                                        </button>
                                        <button
                                            className={`${styles.switchBtn} ${searchMode === 'symptom' ? styles.activeBtn : ''}`}
                                            onClick={() => (setSearchValue(""), setSearchMode('symptom'))}
                                        >
                                            {AIFetching || AiLoading ? "Loading..." : "Symptoms"}
                                        </button>
                                    </div>
                                </div>

                                <div className={styles.searchInput}>
                                    <Input
                                        name='searchValue'
                                        placeholder={searchMode === 'symptom'
                                            ? 'Enter symptoms like headache, cold, etc.'
                                            : 'Search by medicine name like Dolo 650, Crocin...'}
                                        className={`headerSearchInput ${styles.headerSearchNew}`}
                                        value={searchValue}
                                        onChange={handleSearchValue}
                                        endAdornment={<InputAdornment position="end"> {searchValue ==="" ? <SearchIcon /> : <CrossIcon color='#B2B2B2' className='cursor-pointer' onClick={() => setSearchValue("")} />} </InputAdornment>}
                                    />
                                </div>
                            </div>
                            {
                                searchMode === "symptom" ?
                                    <>
                                        {
                                            searchAIDataList && searchResultShow &&
                                            <div className={`${styles.searchResultBox} ${styles.AISearchResultBox}`}>
                                                {searchAIDataList?.summary && (
                                                    <div className={styles.searchSummaryBox}>
                                                        <h4>Summary</h4>
                                                        <p>{searchAIDataList.summary}</p>
                                                    </div>
                                                )}
                                                {
                                                    searchAIDataList?.recommendations?.length > 0 && (
                                                        <div className={styles.searchRecommendationBox}>
                                                            <h4>Recommended Medicines</h4>
                                                            <ul className={styles.searchListMain}>
                                                                {
                                                                    searchAIDataList?.recommendations?.map((data, index) => {
                                                                        const link = `/detail/${slugify(data?.medicine_name)}-otc${data?.id}`
                                                                        return (
                                                                            <li
                                                                                className={styles.searchList}
                                                                                key={index}
                                                                                onClick={() => handleSearchClick(link, Number(data?.id))}
                                                                            >
                                                                                {data?.medicine_name}
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        }
                                    </>
                                    :
                                    <>
                                        {
                                            searchDataList && searchDataList?.length > 0 && searchResultShow &&
                                            <div className={styles.searchResultBox}>
                                                <ul className={styles.searchListMain}>
                                                    {
                                                        searchDataList?.map((data: any, index) => {
                                                            return (
                                                                <li
                                                                    className={styles.searchList}
                                                                    key={index}
                                                                    onClick={() => handleSearchClick(data?.link, data?.id)}
                                                                >{data?.medicine_name}</li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        }
                                    </>
                            }

                        </div>
                        <div className={styles.navbarRightMain}>

                            <div className={styles.navbarOtherSections}>
                                <div className={styles.uploadPrescriptionBtn}>
                                    <button onClick={() => navigate('/prescription')}><span><UploadIcon /> </span> Upload prescription</button>
                                </div>
                                {/* <div className={styles.offersMain} onClick={() => navigate('/offers')}>
                                    <OffersIcon />
                                    <p>Offers</p>
                                </div> */}
                                <div className={`${styles.offersMain} relative`} onClick={() => navigate('/cart')}>
                                    <CartIcon />
                                    <p>Cart</p>
                                    <div className={styles.cartCount}>
                                        <span>{cartCount || 0}</span>
                                    </div>
                                </div>
                                {
                                    userLogin ?
                                        <div className={styles.myaccountAfterLoginSec}>
                                            <button className={`${styles.loginAndSignupBtn} ${styles.myAccountBtn}`}> <AvtarIcon color='#54A276' /> <span>My Account</span></button>
                                            <div className={styles.myAccountcontentMain}>
                                                <div className={styles.myAccountBox}>
                                                    <ul className={styles.myAccountItemsMain}>
                                                        {
                                                            myAccountLists?.map((item, index) => {
                                                                return (
                                                                    <li className={styles.myAccountItems} key={index} onClick={() => dispatch(setTabValue(item?.tab ? item?.tab : 0))}>
                                                                        <Link to={item?.link}>
                                                                            <span>{item?.icon}</span>
                                                                            <span>{item?.title}</span>
                                                                        </Link>
                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                                <ul className={styles.myAccountItemsMain}>
                                                    <li className={styles.logoutBtnMain}>
                                                        <div className={styles.logoutBtn} onClick={() => dispatch(handleOpenLogoutModal())}>
                                                            <LogoutIcon />
                                                            <h3>Log out</h3>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        :
                                        <div className={styles.loginAndSignupBtn}>
                                            <Link to={'/login'}>Login</Link>
                                            <span>|</span>
                                            <Link to={'/signup'}>Sign up</Link>
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            <div className={styles.bottombarMain}>
                <div className="container-fluid">
                    <ul className={styles.categoryHeaderMain}>
                        {isLoading ? Array.from({ length: 8 }).map((_, index) => <Box key={index} width={145} p={0.7} className="skeletonBox" >
                            <Skeleton variant="rectangular" width="100%" height={15} className="skeletonStyle" />
                        </Box>)
                            :
                            primaryMenuData?.map((item, index) => {
                                return (
                                    <li key={index} className={styles.categoryItem}>
                                        <Link to={item?.cat_url}>{item?.medicine_category}</Link>
                                        {
                                            item?.medicine_child_categories?.length > 0 &&
                                            <div className={`${styles.categoryChildItemMainSection} ${index > 6 ? styles.categoryChildItemMainSectionRight : ''}`}>
                                                <ul className={styles.categoryChildItemMain}>
                                                    {
                                                        item?.medicine_child_categories?.map((childItem: any, childIndex: number) => {
                                                            return (
                                                                <li key={childIndex} className={styles.categoryChildItem}>
                                                                    <Link to={childItem?.cat_url} className={styles.categoryChildItemLink}>
                                                                        {childItem?.child_name}
                                                                    </Link>
                                                                    {
                                                                        childItem?.child && childItem?.child?.length > 0 &&
                                                                        <DropdownRightIcon />
                                                                    }
                                                                    {
                                                                        childItem?.child && childItem?.child?.length > 0 &&
                                                                        <div className={styles.categorySubChildSection}>
                                                                            <ul className={styles.categorySubChildMain}>
                                                                                {
                                                                                    childItem?.child?.map((subChildItems: any, subChildIndex: number) => {
                                                                                        return (
                                                                                            <li className={styles.categorySubChildItems} key={subChildIndex}>
                                                                                                <Link to={subChildItems?.cat_url}>{subChildItems?.child_name}</Link>
                                                                                            </li>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </ul>
                                                                        </div>

                                                                    }
                                                                </li>
                                                            )
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        }
                                    </li>
                                )
                            })
                        }

                    </ul>
                </div>
            </div>
            <LogoutModal />
        </div>
    )
}

export default Header